export class Slider {
	/**
	 * Initialize a new Sections element
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {object} opts -
	 */
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			back: '.card-slider__go--back',
			forward: '.card-slider__go--forward',
			content: '.card-slider__content',
			items: '.card-slider__content > *',
			autoscroll: 'card-slider__auto-scroll',
			sticky: true,
			...opts,
		};

		if ( ! this.node ) {
			return;
		}

		this.interval = null;
		this.back = this.node.querySelector( this.opts.back );
		this.forward = this.node.querySelector( this.opts.forward );
		this.content = this.node.querySelector( this.opts.content );
		this.items = this.node.querySelectorAll( this.opts.items );

		this.hasAutoscroll = this.node.classList.contains(this.opts.autoscroll);

		window.addEventListener( 'resize', this.setState.bind( this ) );
		this.content.addEventListener( 'scroll', this.setState.bind( this ) );

		this.forward.addEventListener( 'click', this.forwardIndex.bind( this ) );
		this.back.addEventListener( 'click', this.backIndex.bind( this ) );

		this.setIndex( 0 );
		this.setState();
	}

	autoscroll() {
		const flavoursContainer = document.getElementById('flavoursContainer');
		const containerWidth = container.scrollWidth;

		window.addEventListener('load', () => {
			self.setInterval(() => {
				if (flavoursContainer.scrollLeft !== flavoursScrollWidth) {
					flavoursContainer.scrollTo(flavoursContainer.scrollLeft + 1, 0);
				}
			}, 15);
		});
	}

	/**
	 * Scroll forward the scrollable content area
	 */
	scrollForward() {
		this.scrollInterval = setInterval( () => {
			this.content.scrollTo( { left: this.content.scrollLeft + 5 } );

			if ( this.forward.disabled ) {
				this.scrollStop();
			}
		}, 10 );
	}

	/**
	 * Scroll backwards the scrollable content area
	 */
	scrollBack() {
		this.scrollInterval = setInterval( () => {
			this.content.scrollTo( { left: Math.max( 0, this.content.scrollLeft - 5 ) } );

			if ( this.back.disabled ) {
				this.scrollStop();
			}
		}, 10 );
	}

	/**
	 * Stop the scrolling interval if it's active
	 */
	scrollStop() {
		if ( typeof this.scrollInterval === 'number' ) {
			clearInterval( this.scrollInterval );
		}

		this.scrollInterval = null;
	}

	setState() {
		const firstItem = this.items[ 0 ];
		const lastItem = this.items[ this.items.length - 1 ];

		if ( firstItem.offsetLeft - this.content.scrollLeft >= 0 ) {
			// first item is is view
			this.back.disabled = true;
		} else {
			// first item is outside the scroll area
			this.back.removeAttribute( 'disabled' );
		}

		if ( this.content.scrollLeft + this.content.offsetWidth >= lastItem.offsetLeft + lastItem.offsetWidth - 1 ) {
			// the last item is fully in view
			this.forward.disabled = true;
		} else {
			// last item is outside the scroll area
			this.forward.removeAttribute( 'disabled' );
		}
	}

	getIndex() {
		const offset = this.getPaddingOffset();
		const distances = [ ...this.items ].map( ( item ) => Math.abs( item.offsetLeft - this.content.scrollLeft - offset ) );

		return distances.indexOf( Math.min( ...distances ) );
	}

	getPaddingOffset() {
		return Math.max( parseInt( getComputedStyle( this.content ).paddingLeft, 10 ), 0 );
	}

	setIndex( index, behavior = 'smooth' ) {
		if ( index <= this.items.length ) {
			const left = this.items[ index ].offsetLeft - this.getPaddingOffset();

			this.content.scrollTo( {
				left: Math.max( 0, left ),
				behavior,
			} );
		} else if ( interval > 0 ) {
			clearInterval( interval );
			interval = null;
		}
	}

	backIndex() {
		this.setIndex( Math.round( Math.max( this.getIndex() - 1, 0 ) ) );
	}

	forwardIndex() {
		this.setIndex( Math.round( Math.min( this.getIndex() + 1, this.items.length - 1 ) ) );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.card-slider' ).forEach( ( node ) => {
		new Slider( node, { ...node.dataset } );
	} );
} );
